import React from 'react';
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Our Modern Technology Stack</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
            We're fully capable of providing you the right technology talent for the following technologies and development languages:
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Mobile Frontend">
              <ul>
                <li>Native (Java/Kotlin)</li>
                <li>Xamarin Native C</li>
                <li>Xamarin Forms for Android</li>
                <li>Cordova/PhoneGap</li>
                <li>Ionic</li>
                <li>React Native</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="SDKs/Tools/Framework">
              <ul>
                <li>Android Studio</li>
                <li>Google Fit SDK</li>
                <li>Google Assistant SDK</li>
                <li>OpenGL</li>
                <li>ARCore</li>
                <li>Android Auto</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Operating System">
              <ul>
                <li>Android OS</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Platforms">
              <ul>
                <li>Amazon Web</li>
                <li>Services (AWS)</li>
                <li>Microsoft Azure</li>
                <li>Google Cloud</li>
                <li>Platform (GCP)</li>
                <li>Firebase</li>
                <li>AppCenter for CI/CD</li>
                <li>Kubernetes</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Others">
              <ul>
                <li>Google Assistant</li>
                <li>Google VR</li>
                <li>Machine Learning(ML Kit)</li>
                <li>Firebase</li>
                <li>Google Cloud</li>
                <li>Google Analytics</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
